<template>
  <div class="profile tw-mb-20">
    <div class="item-a">
      <v-avatar size="140" color="white">

        <img class="img-avatar img-show" v-if="profile.imageProfileUrl && typeof profile.imageProfileUrl !== 'string'"
             :src="profile.imageProfileShow"
             alt="upload">

        <img class="img-avatar" v-else-if="profile.imageProfileUrl && typeof profile.imageProfileUrl === 'string'"
             :srcset="profile.imageProfileUrl + '=c-w320, ' + profile.imageProfileUrl + '=c-w480 1.5x, '+ profile.imageProfileUrl + '=c-w640 2x'"
             :src="profile.imageProfileUrl + '=c-w640'" alt="profile"/>

      </v-avatar>
      <v-file-input
        :class="!profile.imageProfileUrl ? 'icon-upload': 'icon-upload icon-white'"
        label="File input"
        filled
        prepend-icon="mdi-image-plus"
        hide-input
        accept="image/*"
        @change="changeImage"
        :disabled="loading"
      ></v-file-input>
      <v-progress-circular
        v-if="uploadImgState && (updateProfileStatus !== 'success')"
        :rotate="-90"
        :size="140"
        :width="6"
        :value="uploadImgState"
        color="teal"
        class="loading-img"
      >
      </v-progress-circular>
    </div>
    <div class="div-tab">
      <div class="active-tab"></div>
      <span class="text-tab">ข้อมูลส่วนตัว</span>
    </div>
    <div class="item-b">
      <v-card height="100%" class="card-detail">
        <v-card-text>
          <h2 class="text-header tw-text-lg tw-font-bold">ข้อมูลส่วนตัว</h2>
          <v-row style="margin-top: 10px">
            <v-col class="col-input">
              <div class="div-input">
                <v-text-field
                  class="input-profile"
                  v-model="profile.nameFirstTH"
                  label="ชื่อ"
                  outlined
                  :disabled="loading"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-input">
              <div class="div-input">
                <v-text-field
                  class="input-profile"
                  v-model="profile.nameLastTH"
                  label="นามสกุล"
                  outlined
                  :disabled="loading"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-input">
              <div class="div-input">
                <v-text-field
                  class="input-profile"
                  v-model="profile.nameFirstEN"
                  label="Firstname"
                  outlined
                  :disabled="loading"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-input">
              <div class="div-input">
                <v-text-field
                  class="input-profile"
                  v-model="profile.nameLastEN"
                  label="Lastname"
                  outlined
                  :disabled="loading"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-input">
              <div class="div-input">
                <v-text-field
                  class="input-profile"
                  v-model="profile.companyName"
                  label="บริษัท"
                  outlined
                  :disabled="loading"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-input">
              <div class="div-input">
                <v-text-field
                  class="input-profile"
                  v-model="profile.email"
                  label="อีเมล"
                  outlined
                  :disabled="loading"
                  :error-messages="emailErrorText"
                  @input="clearErrorEmail"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-input">
              <div class="text-title-password">
                <v-row>
                  <v-col class="text-password">
                    รหัสผ่าน
                  </v-col>
                  <v-col class="text-right">
                    <ResetPassword v-if="!loading"></ResetPassword>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-input">
              <div class="div-input">
                <v-text-field
                  class="input-profile"
                  v-model="password"
                  label="พาสเวิร์ด"
                  type="password"
                  outlined
                  disabled
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="updateProfileStatus">
            <v-col class="col-input">
              <div class="div-input">
                <save-alert :status="updateProfileStatus" error-text="ไม่สามารถบันทึกได้ กรุณาลองใหม่อีกครั้ง"
                            success-text="บันทึกสำเร็จ" v-if="!loading"></save-alert>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-button">
              <div class="div-button" >
                <v-btn @click="onClickSubmit" color="green darken-1" class="button-submit tw-text-white" :loading="loading"  :disabled="loading">
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  บันทึก
                </v-btn>
              </div>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
      <v-dialog v-model="passwordDialog" persistent max-width="600px">
        <template>
          <v-form ref="form">
            <v-card>
              <v-card-title>
                <b>กรอกรหัสผ่าน</b>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-text-field
                        
                        name="password"
                        label="รหัสผ่าน"
                        v-model="passwordInputModel"
                        :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                        :type="showPassword ? 'text' : 'password'"
                        @click:append="showPassword = !showPassword"
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="clearPassword">
                  <v-icon large>mdi-close-circle-outline</v-icon>
                  <b>ยกเลิก</b>
                </v-btn>
                <v-btn text color="#6ec39b" type="button" class="submit-email" @click="setPassword">
                  <img
                    src="/images/icons/icon_send_email.svg"
                    style="max-height: 26px; max-width: 26px;"
                    class="mr-2" />
                  <b>ยืนยันรหัสผ่าน</b>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </template>
      </v-dialog>

    </div>
  </div>
</template>
<script>

import ResetPassword from '../../../components/admin/profile/reset-password'
import SaveAlert from '../save-alert'
import {mapState} from "vuex";
import { checkImageSmall } from "../../../libs/validateImageUpload";
import loading from '@/store/modules/loading';

const _ = require('lodash');

export default {
  name: "ProfileDetail",
  components: {
    ResetPassword,
    SaveAlert
  },
  computed: mapState({
    userProfile: state => state.user.userProfile,
    uploadImgState : state => state.user.uploadImgState,
    loading: state => state.user.loading,
    updateProfileStatus: state => state.user.updateProfileStatus,
    passwordDialog: state => state.user.passwordDialog,
    passwordInput: state=> state.user.passwordInput,
  }),
  data: function () {
    return {
      password: "password",
      profile: {...this.userProfile},
      emailErrorText: "",
      passwordInputModel: '',
      showPassword: false,
    }
  },
  mounted() {
    this.getUserProfile();
  },
  watch: {
    userProfile: {
      handler: function () {
        this.profile = {...this.userProfile}
      },
    },
    updateProfileStatus: {
      handler: function () {
        if(this.updateProfileStatus === 'success' && !this.loading){
          this.getUserProfile()
          this.$store.dispatch('user/get')
        }
      },
    },
  },
  methods:{
    clearPassword: function() {
      this.$store.dispatch('user/setPasswordUpdateEmail','')
      this.$store.dispatch('setPasswordDialog', false)
    },
    setPassword: function(){
      this.$store.dispatch('user/setPasswordUpdateEmail',  this.passwordInputModel)
      this.$store.dispatch('user/validateCredentialUpdateEmail')
    },
    getUserProfile: function (){
      this.$store.dispatch('user/getUserProfile')
    },
    onClickSubmit: function () {
      let changeEmail = false
      if (!_.isEqual(this.profile['email'], this.userProfile['email']) && this.profile['email'] !== "") {
        changeEmail = true
      }
      this.$store.dispatch('user/setProfileLoadingEmpty')
      this.$store.dispatch('user/updateUser', {profile: this.profile, changeEmail: changeEmail}).then((result) => {
        if (result && result === "email is duplicate") {
          this.emailErrorText = 'อีเมลนี้มีผู้ใช้งานแล้ว'
        }
      })
    },
    changeImage: function (event) {
      if (event) {
        checkImageSmall(event).then((imageSmall) => {
          if (imageSmall) {
            alert("width lower 640 pixels. please select new image.")

          } else {
            let dataSet = _.cloneDeep(this.profile)
            dataSet.imageProfileUrl = event
            dataSet.imageProfileShow = URL.createObjectURL(event)
            this.profile = dataSet
          }
        })
      }
    },
    clearErrorEmail: function (){
      if(this.emailErrorText){
        this.emailErrorText = ""
      }
    },
  },
}
</script>

<style lang="scss">
.profile {
  display: flex;
  height: 100%;
  justify-content: center;
  flex-direction: column;
}
.item-a {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-b {
  flex: 6;
}
.div-input{
  width: 40%;
}
.col-input{
  display: flex;
}
.img-avatar {
  border: 4px solid white;
}
//.input-profile .v-text-field__details {
//  display: none !important;
//}
.col-button{
  display: flex;
  flex-direction: row;
}
.div-button{
  width: 40%;
}
.button-submit{
  float: right;
}
.v-text-field fieldset{
  border-radius: 10px;
}
.text-header{
  padding-top: 1rem;
  padding-bottom: 0.25rem;
}
.text-title-password{
  width: 40%;
}
.img-edit{
  text-align: right;
}
.text-button-edit{
  font-size: 18px !important;
  font-weight: bold !important;
  color: rgba(0, 0, 0, 0.6) !important;
  letter-spacing: unset !important;
}
.card-detail{
  padding-left: 24px;
}
.text-password{
  font-size: 1.5em!important;
  font-weight: bold !important;
  display: flex;
  align-items: center;
}
.div-tab{
  width: 160px;
  height: 52px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  margin: 0 0 -5px 16px;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px 80px 10px 10px;
  background-color: white;
  cursor: pointer;
}
.text-tab{
  color: #c9242b;
  font-size: 20px;
}
.active-tab{
  width: 4px;
  height: 32px;
  background-color: #c9242b;
  position: absolute;
  left: 16px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.icon-upload{
  position: absolute;
  top: 123px;
}
.icon-white .v-icon {
  //color: white;
  filter: invert(1);
  mix-blend-mode: difference;
}
.v-application--is-ltr .v-input__prepend-outer{
  margin-right: unset !important;
  margin-top: unset !important;
}
.loading-img{
  position: absolute !important;
}
.img-show{
  object-fit: cover;
}
@media all and (max-width: 800px) and (min-width: 701px){
  .div-input, .div-button, .text-title-password{
    width: 60%;
  }
  .card-detail{
    padding-left: unset;
  }
}

@media all and (max-width: 700px) {
  .div-input, .div-button, .text-title-password{
    width: 100%;
  }
  .card-detail{
    padding-left: unset;
  }
}
</style>
